export function legendDblClick(Highcharts) {
    Highcharts.Legend.prototype.setItemEvents = function (item, legendItem, useHTML, itemStyle, itemHiddenStyle) {
        const legend = this;
        let timer = 0;
        const delay = 200;
        let prevent = false;
        const fireEvent = Highcharts.fireEvent;
        const boxWrapper = legend.chart.renderer.boxWrapper;
        const merge = Highcharts.merge;
        const activeClass = `highcharts-legend-${item.series ? 'point' : 'series'}-active`;
        if (item.legendSymbol) {
            item.legendSymbol.on('click', function () {
                const anchor = item.legendSymbol.element;
                legend.options.symbolClick(item, anchor);
            });
        }
        else if (item.legendLine) {
            item.legendLine.on('click', function () {
                const anchor = item.legendLine.element;
                legend.options.symbolClick(item, anchor);
            });
        }
        else {
            console.warn('No symbols defined for the legend');
        }
        legendItem
            .on('mouseover', function () {
            item.setState('hover');
            boxWrapper.addClass(activeClass);
            legendItem.css(legend.options.itemHoverStyle);
        })
            .on('mouseout', function () {
            legendItem.css(merge(item.visible
                ? legend.itemStyle
                : legend.itemHiddenStyle));
            boxWrapper.removeClass(activeClass);
            item.setState();
        })
            .on('click', function (event) {
            timer = setTimeout(function () {
                if (!prevent) {
                    doClickAction(event);
                }
                prevent = false;
            }, delay);
        })
            .on('dblclick', function (event) {
            clearTimeout(timer);
            prevent = true;
            legend.options.dblClick(item);
        });
        function doClickAction(event) {
            const strLegendItemClick = 'legendItemClick';
            const fnLegendItemClick = function () {
                if (item.setVisible) {
                    item.setVisible();
                }
            };
            event = {
                browserEvent: event,
            };
            if (item.firePointEvent) {
                item.firePointEvent(strLegendItemClick, event, fnLegendItemClick);
            }
            else {
                fireEvent(item, strLegendItemClick, event, fnLegendItemClick);
            }
        }
    };
}
//# sourceMappingURL=legend-dblclick.js.map